import logo from '../eye-mask.svg'
import { IMChatStore } from '../stores/IMChatStore';

export function StartHelloComp(props: {store: IMChatStore}) {
    return (<div className='absolute cont-start-hello flex-row ' onClick={()=>props.store.startHello()}
    style={{
        bottom: 80
    }}>
        <img src={logo} style={{width:30, height:25}} />
        <h4 style={{marginLeft: 5}} >Say Hello :)</h4>
    </div>);
}

